import { render, staticRenderFns } from "./DocumentSelection.vue?vue&type=template&id=e011c174&"
import script from "./DocumentSelection.vue?vue&type=script&lang=js&"
export * from "./DocumentSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports